document.addEventListener("DOMContentLoaded", () => {
  console.log("%c[Mobile Drawer]", "background:#000;color:#fff;", "Init");

  const waitForLoopWidget = (cb) => {
    const intv = setInterval(() => {
      const loop = document.querySelector(".loop-widget-container");
      if (loop && loop.querySelectorAll(".loop-widget-purchase-option").length > 0) {
        clearInterval(intv);
        cb(loop);
      }
    }, 250);
  };

  waitForLoopWidget((loopContainer) => {
    const productType = window.productPurchaseType || "Single";
    //const mainForm = document.querySelector("form[action='/cart/add']");
    const mainForm = Array.from(document.querySelectorAll("form[action='/cart/add']")).find(form => form.offsetParent !== null);
    if (!mainForm) return;

    // --- DOM Elements ---
    const imgEl = document.querySelector(".product-media--container .product-media--root img");
    const imgElo = document.querySelector('.main-product--mobile[data-type="optional"] .product-media--container .product-media--root img');
    const titleEl = document.querySelector(".product-form--block--heading");
    const iconsEl = document.querySelector(".product-icons");
    const productBannerEL = document.querySelector(".product-banner");

    let subDesc = "";
    let oneTimeDesc = "";

    if (productType === "Single") {
      // For single SKU
      subDesc = `<ul class="loop-desc">
          <li>buy 5+ to subscribe</li>
          <li>save 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>
        <div class="desc-bottom">Subscription requires a minimum of 5 masks per order.</div>
        `;
      oneTimeDesc = ""; // optional – no one-time description for singles
    }

    else if (productType === "Starter Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks shipped monthly</li>
          <li>3 everyday facial sheet masks shipped monthly</li>
          <li><b>free</b> rini headband one-time shipment</li>
          <li>pause, cancel, or adjust at anytime</li>
        </ul>`;
      oneTimeDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks</li>
          <li>3 everyday facial sheet masks</li>
          <li class="no">no free headband</li>
        </ul>`;
    }

    else if (productType === "Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>save 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
      oneTimeDesc = ``;
    }

    else if (productType === "Bundle with subscription only") {
      subDesc = ``;
      oneTimeDesc = "";
    }

    
    //const oneTimePrice = loopContainer.querySelector(".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price-container");
    const oneTimePrice = document.querySelector(".product-price--wrapper");
    const subPrice = loopContainer.querySelector("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-container");

    const realQty = mainForm.querySelector('input[name="quantity"]');
    const realSubmit = mainForm.querySelector('button[type="submit"]');
    const oneTimeOption = loopContainer.querySelector(".loop-widget-purchase-option-onetime");
    const subOption = loopContainer.querySelector("[data-loop-widget-selling-plan-group]");
    // Loop's real delivery-frequency selector (lives inside the subscription option).
    // We move this live node into the drawer so its own handlers keep updating selling_plan.
    let freqSelector = subOption ? subOption.querySelector(".loop-widget-spg-container") : null;
    const freqOriginalParent = freqSelector ? freqSelector.parentNode : null;
    const isOutOfStock = realSubmit && realSubmit.disabled;
    const footer = document.querySelector(".layout--footer-group");


    



    // --- Overlay (bound to body) ---
    let overlay = document.querySelector("#drawer-overlay-global");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "drawer-overlay-global";
      document.body.appendChild(overlay);
    }

    // --- Drawer ---
    const drawer = document.createElement("div");
    drawer.className = "mobile-drawer collapsed";
    drawer.innerHTML = `
      <div class="drawer-inner">
        <div class="drawer-header">
          <div class="drawer-info">
            <img class="drawer-main-image" src="${imgEl?.src || ""}" alt="">
            ${imgElo ? `<img class="drawer-optional-image" style="display:none" src="${imgElo?.src || ""}" alt="">` : ""}
            <div class="drawer-title">
              <div>
                  <div>${titleEl?.innerHTML || ""}</div>
                  <span class="drawer-badge" style="border-radius: 30px; background: rgb(237, 249, 179); padding: 2px 7px; font-weight: 500; display:none; margin-right:auto; margin-top:5px">33% off</span>
              </div>
              <div class="drawer-price">${oneTimePrice?.outerHTML || ""}</div>
            </div>
          </div>
          <button class="drawer-close">×</button>
        </div>

        <div class="drawer-features"></div>

        <div class="drawer-frequency" style="display:none"></div>

        <div class="drawer-qty">
          <button class="minus">−</button>
          <input type="text" value="${realQty?.value || 1}" readonly>
          <button class="plus">+</button>
        </div>

        <div class="drawer-actions">
          ${
            isOutOfStock
              ? `<button class="ghost-btn outofstock" disabled>Out of stock</button>`
              : `
                <button class="ghost-btn onetime">Buy one-time</button>
                <button class="ghost-btn subscribe">Subscribe • Save 10%</button>
              `
          }
        </div>
        <div class="drawer-terms"></div>
        <div class="drawer-freegift" style="display:none">
          <div class="product-banner">
            <div class="text">
              You've unlocked <br/> a free rini headband!
            </div>
            <div class="image">
              <img src="https://cdn.shopify.com/s/files/1/0893/2746/8728/files/freeheadband.png?v=1763036838" width="auto" height="auto" />
            </div>
          </div>
        </div>
        <div class="drawer-bottom">${iconsEl?.outerHTML || ""}</div>
      </div>
    `;
    document.body.appendChild(drawer);

    const actionTerms = drawer.querySelector(".drawer-terms");
    const waitForPaymentTerms = setInterval(() => {
      const el = document.querySelector('shopify-payment-terms');
      if (el) {
        clearInterval(waitForPaymentTerms);
        actionTerms.innerHTML = el.outerHTML;
      }
    }, 300);

    // --- Scroll hide/show ---
    let lastScrollTime = 0;
    let hideTimeout;

    window.addEventListener("scroll", () => {
      if (window.innerWidth > 767) return;

      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const windowHeight = window.innerHeight;

      // Hide if near or overlapping footer
      if (footerTop < windowHeight + 40) {
        drawer.classList.add("hide");
        return;
      }

      // Skip hiding if expanded
      if (drawer.classList.contains("expanded")) return;

      drawer.classList.add("hide");
      lastScrollTime = Date.now();

      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        if (Date.now() - lastScrollTime >= 200) drawer.classList.remove("hide");
      }, 250);
    });

    const qtyInput = drawer.querySelector("input");
    const plusBtn = drawer.querySelector(".plus");
    const minusBtn = drawer.querySelector(".minus");
    const oneTimeBtn = drawer.querySelector(".onetime");
    const subBtn = drawer.querySelector(".subscribe");
    const closeBtn = drawer.querySelector(".drawer-close");
    const features = drawer.querySelector(".drawer-features");
    const freqContainer = drawer.querySelector(".drawer-frequency");
    const priceDisplay = drawer.querySelector(".drawer-price");
    const actionWrapper = drawer.querySelector(".drawer-actions");
    const freegift = drawer.querySelector(".drawer-freegift");
    const drawerBadge = drawer.querySelector(".drawer-badge");
    const drawerImage = drawer.querySelector(".drawer-main-image");
    const drawerImageOpt = drawer.querySelector(".drawer-optional-image");
    
    if(productBannerEL) {
      freegift.innerHTML = productBannerEL.outerHTML;
      freegift.style.display = "";
    }
    

    if (isOutOfStock) return;


    /* -------------------------------
      MOBILE PRODUCT MEDIA SWITCHER
    --------------------------------*/
    const mobileMainGallery = document.querySelector('.main-product--mobile:not([data-type="optional"])');
    const mobileOptionalGallery = document.querySelector('.main-product--mobile[data-type="optional"]');

    const hasMobileOptional = mobileOptionalGallery !== null;

    function updateMobileGallery(mode) {
      
      if (!hasMobileOptional) return;   // do nothing if optional gallery missing
      
      if (productType !== "Starter Bundle") return;

      subBtn.textContent = "Subscribe • Save 33%";

      if (mode=='subscribe') {
        // Subscription selected → show main, hide optional
        /*
        if (mobileMainGallery) mobileMainGallery.style.display = "";
        mobileOptionalGallery.style.display = "none";
        */

        mobileMainGallery.style.display = "none";
        mobileOptionalGallery.style.display = "";

        //show free gift. hide terms
        freegift.style.display = "";
        drawerBadge.style.display = "inline-block";
        actionTerms.style.display = "none";
        drawerImage.style.display = "none";
        drawerImageOpt.style.display = "";

        const subPriceOrg = drawer.querySelector(".loop-widget-purchase-option-price");
        const subPriceComp = drawer.querySelector(".loop-widget-purchase-option-compare-at-price");

        subPriceComp.textContent = "$42.00";

      } else if(mode == 'onetime') {
        // One-time selected → show optional, hide main
        /*
        if (mobileMainGallery) mobileMainGallery.style.display = "none";
        mobileOptionalGallery.style.display = "";
        */
        mobileMainGallery.style.display = "";
        mobileOptionalGallery.style.display = "none";

        //hide free gift. show terms
        freegift.style.display = "none";
        drawerBadge.style.display = "none";
        actionTerms.style.display = "";

        drawerImage.style.display = "";
        drawerImageOpt.style.display = "none";

        const oneTimePriceOrg = drawer.querySelector(".product-price--original");
        const oneTimePriceComp = drawer.querySelector(".product-price--compare");
        oneTimePriceComp.style.display = "none"
  
      } else {
        //default

      }
    }

    // Run once
    updateMobileGallery();

    // --- State ---
    let activeMode = null;
    let minQty = 1;

    // --- Helpers ---
    const updateQty = (val) => {
      val = Math.max(minQty, parseInt(val, 10));
      qtyInput.value = val;
      if (realQty) realQty.value = val;
    };

    const showToast = (msg) => {
      const toast = document.createElement("div");
      toast.className = "drawer-toast";
      toast.textContent = msg;
      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 2000);
    };

    const expandDrawer = (mode) => {
      drawer.classList.add("expanded");
      drawer.classList.remove("collapsed");
      overlay.classList.add("visible");
      document.body.classList.add("no-scroll");

      features.innerHTML =
        mode === "subscribe" ? subDesc || "" : oneTimeDesc || "";
      priceDisplay.innerHTML =
        mode === "subscribe" ? subPrice?.innerHTML || "" : oneTimePrice?.outerHTML || "";

      oneTimeBtn.classList.toggle("active", mode === "onetime");
      subBtn.classList.toggle("active", mode === "subscribe");

      // Surface Loop's real frequency selector only in the subscribe view.
      // Re-query in case Loop re-rendered and replaced the cached node.
      if (!freqSelector || !freqSelector.isConnected) {
        freqSelector = subOption ? subOption.querySelector(".loop-widget-spg-container") : null;
      }
      if (mode === "subscribe" && freqSelector) {
        freqContainer.appendChild(freqSelector);   // moves the live node
        freqContainer.style.display = "";
      } else {
        if (freqSelector && freqOriginalParent) freqOriginalParent.appendChild(freqSelector);
        freqContainer.style.display = "none";
      }

      window.dispatchEvent(new CustomEvent('bundle:update'));
    };

    const collapseDrawer = () => {
      drawer.classList.add("collapsed");
      drawer.classList.remove("expanded");
      overlay.classList.remove("visible");
      document.body.classList.remove("no-scroll");

      features.innerHTML = "";
      // Return Loop's frequency selector to its widget so Loop's DOM stays intact.
      if (freqSelector && freqOriginalParent && freqContainer.contains(freqSelector)) {
        freqOriginalParent.appendChild(freqSelector);
      }
      freqContainer.style.display = "none";
      priceDisplay.innerHTML = oneTimePrice?.outerHTML || "";
      oneTimeBtn?.classList.remove("active");
      subBtn?.classList.remove("active");
      activeMode = null;
      minQty = 1;
    };

    // --- Quantity control ---
    plusBtn.addEventListener("click", () => updateQty(parseInt(qtyInput.value) + 1));
    minusBtn.addEventListener("click", () => updateQty(parseInt(qtyInput.value) - 1));

    // --- Button logic ---
    const handleBuyClick = (mode) => {
      minQty = mode === "subscribe" && productType === "Single" ? 5 : 1;

      // First click: expand + enforce min qty
      if (!drawer.classList.contains("expanded")) {
        if (mode === "subscribe" && parseInt(qtyInput.value, 10) < minQty) {
          updateQty(minQty);
        }
        expandDrawer(mode);
        activeMode = mode;
        updateMobileGallery(mode);
        return;
      }

      // Switching mode after expanded
      if (activeMode !== mode) {
        if (mode === "subscribe" && parseInt(qtyInput.value, 10) < minQty) {
          updateQty(minQty);
        }
        expandDrawer(mode);
        activeMode = mode;
        updateMobileGallery(mode);
        return;
      }

      // ✅ Trigger Loop option click
      if (mode === "subscribe" && subOption) subOption.click();
      else if (mode === "onetime" && oneTimeOption) oneTimeOption.click();

      

      // Delay for Loop to process
      setTimeout(() => {
        realSubmit.click();
        collapseDrawer();
        const successText = `adding to cart...`;
        priceDisplay.innerHTML = successText;
        actionWrapper.style.display = "none";
        actionTerms.style.display = "none";
      }, 100);

      setTimeout(() => {
        collapseDrawer();
        actionWrapper.style.display = "flex";
      }, 2000)
      
      
      
    };

    oneTimeBtn?.addEventListener("click", () => handleBuyClick("onetime"));
    subBtn?.addEventListener("click", () => handleBuyClick("subscribe"));
    closeBtn.addEventListener("click", collapseDrawer);
    overlay.addEventListener("click", collapseDrawer);

  
    // --- Responsive check ---
    const toggleDrawerVisibility = () => {
      drawer.style.display = window.innerWidth <= 767 ? "block" : "none";
    };
    toggleDrawerVisibility();
    window.addEventListener("resize", toggleDrawerVisibility);
  });
});